<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Fase"
                @click.stop="abrirModalAtualizarFase()"
            ></i>
        </span>
        <b-modal
            id="modalAtualizarFase"
            v-model="mostrarModalAtualizarFase"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Fase do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O que deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group
                            v-model="contratoApostilamento"
                            @change="alternaJustificativa($event)"
                        >
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <app-detalhe2 titulo="Tipo da Fase">
                <strong>{{ fase.tipoFaseContrato }}</strong>
            </app-detalhe2>
            <b-row v-if="fase.tipoFaseContratoId === 1" class="mb-2">
                <b-col sm="12">
                    <b-form-checkbox
                        v-model="requerAprovacao"
                        :value="true"
                        :unchecked-value="false"
                    >
                        Requer Aprovação
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group
                        :state="$v.vigenciaInicio.$error ? false : null"
                        invalid-feedback="Data do início da vigência é obrigatória"
                    >
                        <label>Vigência Início</label>
                        <date-picker
                            v-model="vigenciaInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaInicio.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <!-- </b-row>
                <b-row>-->
                <b-col>
                    <b-form-group
                        :state="$v.vigenciaFim.$error ? false : null"
                        invalid-feedback="Data do fim da vigência é obrigatória"
                    >
                        <label>Vigência Fim</label>
                        <date-picker
                            v-model="vigenciaFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input.native="$v.vigenciaFim.$touch()"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é inválido"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="fase.tipoFaseContratoId !== 3">
                <b-col sm="12">
                    <b-form-group>
                        <label>Item de Contrato</label>
                        <b-form-select
                            :options="itensContrato"
                            v-model="itemContratoId"
                            text-field="descricao"
                            value-field="itemContratoId"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{ labelJustificativa }}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{ textoInfoJustificativa }} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizarFase()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarFase()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        fase: {
            type: Object,
            default: () => ({})
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModalAtualizarFase: false,
            obterFasesAtualizadas: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            descricao: '',
            valor: 0,
            vigenciaInicio: null,
            vigenciaFim: null,
            itemContratoId: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: '',
            requerAprovacao: true
        }
    },

    methods: {
        abrirModalAtualizarFase() {
            this.mostrarModalAtualizarFase = true
        },

        fecharModalAtualizarFase() {
            this.mostrarModalAtualizarFase = false
            this.resetAtualizarFase()
            if (this.obterFasesAtualizadas) {
                this.$emit('obterFasesAtualizadas')
            }
        },

        resetAtualizarFase() {
            this.justificativaApostilamento = ''
            this.descricao = ''
            this.valor = 0
            this.vigenciaInicio = null
            this.vigenciaFim = null
            this.itemContratoId = 0
            this.erros = []
            this.requerAprovacao = true
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterFasesAtualizadas = false
            this.descricao = this.fase.descricao.trim()
            this.valor = this.fase.valor
            this.itemContratoId = this.fase.itemContratoId
            this.vigenciaInicio = this.$moment(
                this.fase.dataInicioVigencia
            ).format('DD/MM/YYYY')
            this.vigenciaFim = this.$moment(this.fase.dataFimVigencia).format(
                'DD/MM/YYYY'
            )
            this.requerAprovacao = this.fase.requerAprovacao
        },

        confirmarSalvarFase() {
            this.$swal({
                title: 'Fase do Contrato',
                html: `Confirma a atualização da fase <b>${this.fase.tipoFaseContrato}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarFase()
                }
            })
        },

        salvarFase() {
            this.$store.dispatch('addRequest')
            let faseAtualizadaDto = {
                faseContratoId: this.fase.faseContratoId,
                tipoFaseContratoId: this.fase.tipoFaseContratoId,
                idContrato: this.$route.params.contratoId,
                itemContratoId: this.itemContratoId,
                descricao: this.descricao,
                valor: this.valor,
                dataInicioVigencia: this.$moment(
                    this.vigenciaInicio,
                    'DD/MM/YYYY'
                ),
                dataFimVigencia: this.$moment(this.vigenciaFim, 'DD/MM/YYYY'),
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false,
                requerAprovacao: this.requerAprovacao
            }
            ContratosServicos.atualizarFaseContrato(faseAtualizadaDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterFasesAtualizadas = true
                            this.fecharModalAtualizarFase()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registrosInalterados() {
            if (this.descricao) {
                return (
                    this.descricao.trim() == this.fase.descricao.trim() &&
                    this.valor == this.fase.valor &&
                    this.vigenciaInicio ==
                        this.$moment(this.fase.dataInicioVigencia).format(
                            'DD/MM/YYYY'
                        ) &&
                    this.vigenciaFim ==
                        this.$moment(this.fase.dataFimVigencia).format(
                            'DD/MM/YYYY'
                        ) &&
                    this.itemContratoId == this.fase.itemContratoId &&
                    this.requerAprovacao == this.fase.requerAprovacao
                )
            }
            return false
        },

        valorIncorreto() {
            if (this.fase.tipoFaseContratoId === 3) {
                if (
                    this.valor < this.fase.valor - this.fase.saldo ||
                    this.valor >
                        this.fase.valor + this.contrato.valorDisponivelFases
                ) {
                    return false
                }
                return true
            } else if (this.fase.tipoFaseContratoId === 1) {
                if (
                    this.valor >
                    this.fase.valor + this.contrato.valorDisponivelFases
                ) {
                    return false
                } else if (
                    this.valor < this.fase.valor - this.fase.disponivel &&
                    this.fase.temDetalhamento
                ) {
                    return false
                }
                return true
            } else if (this.fase.tipoFaseContratoId === 2) {
                if (
                    this.valor >
                    this.fase.valor + this.contrato.valorDisponivelFases
                ) {
                    return false
                } else if (this.valor < this.fase.totalDetalhamento) {
                    return false
                }
                return true
            }
            return true
        },

        itemContratoIdValido() {
            if (this.fase.tipoFaseContratoId !== 3) {
                return this.itemContratoId > 0
            }
            return true
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if (
                (this.apostilamento || this.atualizacaoContrato()) &&
                this.contratoApostilamento != null
            ) {
                return true
            } else if (this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-06')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-06')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        itensContrato() {
            return this.contrato.itensContrato.filter(item => {
                return item.status == 1
            })
        },

        mostrarCheckApostilamento() {
            return this.atualizacaoContrato() && this.apostilamento
        }
    },

    watch: {},

    validations: {
        faseContratoId: {
            registrosAlterados() {
                return !this.registrosInalterados()
            }
        },
        descricao: {
            required
        },
        valor: {
            required,
            valorIncorreto() {
                return this.valorIncorreto()
            },
            minValue: minValue(0.01)
        },
        vigenciaInicio: {
            required
        },
        vigenciaFim: {
            required
        },
        itemContratoId: {
            itemContratoIdValido() {
                return this.itemContratoIdValido()
            }
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
